const baseUrl = process.env.VUE_APP_API_URL;

export default baseUrl;
